/* import __COLOCATED_TEMPLATE__ from './state-badge.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';
import type { ConversationState } from 'embercom/objects/inbox/conversation';

interface Signature {
  Args: {
    state?: ConversationState;
    onClick: () => void;
  };
  Element: HTMLDivElement;
}

const StateBadge = templateOnlyComponent<Signature>();
export default StateBadge;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Common::StateBadge': typeof StateBadge;
    'inbox2/common/state-badge': typeof StateBadge;
  }
}
